export const DAY_TRIPS_COLLECTION_MBS_VIDEOS = {
  'bluemountains.tickets-sydney.com': {
    // 1682
    thumbnail:
      'https://cdn-imgix.headout.com/media/images/c296ad5d0c7f65525fc599d245ddd376-Syd-BM-daytrips%20tn_.png',
    previewVideo:
      'https://headout-videos-hls.imgix.video/dd7afb51f455725958c5d46e594eff6b-Sydney%20day%20trips_preview_720p.mp4?fm=hls',
    video720:
      'https://headout-videos-hls.imgix.video/27f5924b24f37eeefaa1055c31233cd2-Sydney%20day%20trips_720p.mp4?fm=hls',
    video1080:
      'https://headout-videos-hls.imgix.video/0b97d16cce554e5077efba41310b95dd-Sydney%20day%20trips_1080p.mp4?fm=hls',
  },
  'www.phiphi-islands-tours.com': {
    // 2405
    thumbnail:
      'https://cdn-imgix.headout.com/media/images/fbd4d1fb20e7a3a823bf41deddb3ef03-phuket%20to%20phi%20phi%20tn.png',
    previewVideo:
      'https://headout-videos-hls.imgix.video/687b3ae296c9c6373dde8616f3c721a8-Phuket%20to%20Phi%20Phi%20Island%20day%20trips_preview_720p.mp4?fm=hls',
    video720:
      'https://headout-videos-hls.imgix.video/524a05937bc5efdcc851ab87b34358ca-Phuket%20to%20Phi%20Phi%20Island%20day%20trips_720p.mp4?fm=hls',
    video1080:
      'https://headout-videos-hls.imgix.video/353f5a219426fc36ac3711e9ecd7eba3-Phuket%20to%20Phi%20Phi%20Island%20day%20trips_1080p.mp4?fm=hls',
  },
  'www.mount-fuji.com': {
    // 1819
    thumbnail:
      'https://cdn-imgix.headout.com/media/images/9fbba635619b474333a701aee12fa653-tokyo%20to%20mount%20fuji%20tn.png',
    previewVideo:
      'https://headout-videos-hls.imgix.video/f678f73aeee8d0683cd05b57b628d4dd-Mount%20Fuji%20day%20trips_preview_720p.mp4?fm=hls',
    video720:
      'https://headout-videos-hls.imgix.video/280949212c25cd153c881a239529fadf-Mount%20Fuji%20day%20trips_720p.mp4?fm=hls',
    video1080:
      'https://headout-videos-hls.imgix.video/4298c466d6126262f63a23bd8fea6be0-Mount%20Fuji%20day%20trips_1080p.mp4?fm=hls',
  },
  'www.edinburgh-tickets.com.edinburgh-to-loch-ness-tours': {
    // 2361
    thumbnail:
      'https://cdn-imgix.headout.com/media/images/99c88acc880e78acfefd6772f65f32c8-edinburgh%20to%20loch%20ness%20tn%205.png',
    previewVideo:
      'https://headout-videos-hls.imgix.video/45bafb7a2be8ff72e19d7ef11a8dfad5-Edinburgh%20to%20Lochness_preview_720p.mp4?fm=hls',
    video720:
      'https://headout-videos-hls.imgix.video/ed82b1f5d14113210606e67123931051-Edinburgh%20to%20Lochness%20day%20trips_720p.mp4?fm=hls',
    video1080:
      'https://headout-videos-hls.imgix.video/b7dae84377d45895f05f9ea09f579dfb-Edinburgh%20to%20Lochness%20day%20trips_1080p.mp4?fm=hls',
  },
  'www.pompeii-tickets.com.rome-to-pompeii-day-trip': {
    // Rome to Pompeii + Amalfi Coast (CE ID: 3665)
    thumbnail:
      'https://cdn-imgix.headout.com/media/images/e1c88695cd04a20354e650948c9b4713-rome%20to%20pompeii%202.png',
    previewVideo:
      'https://headout-videos-hls.imgix.video/126a3de3223b9f8c4e3930f9f9815a30-Rome%20to%20Pompeii_preview_720p.mp4?fm=hls',
    video720:
      'https://headout-videos-hls.imgix.video/e1b3452ac5e4e16c3eb3484ec312a36e-Rome%20to%20Pompeii%20Day%20trips_720p.mp4?fm=hls',
    video1080:
      'https://headout-videos-hls.imgix.video/077c0fd21da416f78643aee4971d1d08-Rome%20to%20Pompeii%20Day%20trips_1080p.mp4?fm=hls',
  },
  // 'www.pompeii-tickets.com.naples-to-pompeii-day-trip': {
  //   // Rome to Pompeii (CE ID: 3665 + Naples to Pompeii - CE ID: 3664) 3664
  //   thumbnail:
  //     'https://cdn-imgix.headout.com/media/images/02e3444d433cf223305431033009e88c-rome-pompei%20amalfi%20tn3.png',
  //   previewVideo:
  //     'https://headout-videos-hls.imgix.video/2c2eb2683de92ab88c97b66d3b987e5b-Rome%20to%20Amalfi%20preview_720p.mp4?fm=hls',
  //   video720:
  //     'https://headout-videos-hls.imgix.video/9bc9773257340dff051a7441cbb061f2-Rome%20to%20Amalfi%20Day%20trips_720p.mp4?fm=hls',
  //   video1080:
  //     'https://headout-videos-hls.imgix.video/e83dd81f02761f0ba159b56c4645c818-Rome%20to%20Amalfi%20Day%20trips_1080p.mp4?fm=hls',
  // },
  'www.stonehenge-london-tours.com': {
    // London to Stonehenge (CE ID: 212)
    thumbnail:
      'https://cdn-imgix.headout.com/media/images/1e27cbf01983ee430dddb679dce9d0a3-london%20to%20stonehenge%20tn1.png',
    previewVideo:
      'https://headout-videos-hls.imgix.video/823ffffa08aaf514ac1cf15febcbeebb-London%20to%20Stonehenge_preview_720p.mp4?fm=hls',
    video720:
      'https://headout-videos-hls.imgix.video/aa0cfc14ee9a023d244e32c6fcb71d22-London%20to%20Stonehenge%20Day%20trips_720p.mp4?fm=hls',
    video1080:
      'https://headout-videos-hls.imgix.video/5c675e96dda639c181c0435bfd148825-London%20to%20Stonehenge%20Day%20trips_1080p.mp4?fm=hls',
  },
  // 'London to Stonehenge + Bath (CE ID: 212)': {
  //   thumbnail:
  //     'https://cdn-imgix.headout.com/media/images/9c464e6052516e0ac74d6467e11250f6-london%20to%20stonehenge%20and%20bath%20tn%202.png',
  //   previewVideo:
  //     'https://headout-videos-hls.imgix.video/a736a11c8ad964465d0ed09900d1f811-London%20to%20Bath_preview_720p.mp4?fm=hls',
  //   video720:
  //     'https://headout-videos-hls.imgix.video/ae9e4ddd44abee3a994220c239ac50ed-London%20to%20Bath%20day%20trips_720p.mp4?fm=hls',
  //   video1080:
  //     'https://headout-videos-hls.imgix.video/3971d5e8679325f0150e717ac2f9d429-London%20to%20Bath%20day%20trips_1080p.mp4?fm=hls',
  // },
} as Record<
  string,
  {
    thumbnail: string;
    previewVideo: string;
    video720: string;
    video1080: string;
  }
>;

export const DAY_TRIPS_COLLECTION_MBS = Object.keys(
  DAY_TRIPS_COLLECTION_MBS_VIDEOS
);
